let togglerElement = document.getElementById("main-menu-toggler");
let menuElement = document.getElementById("main-menu");
let menuItemElement = document.getElementsByClassName("js-menu-item");
let issueCountElement = document.getElementById('issue-count');

togglerElement.addEventListener("click", () => {
	if (menuElement.classList.contains('d-none')) {
		menuElement.classList.remove('d-none');
	} else {
		menuElement.classList.add('d-none');
	}

	return false;
});

for (let i = 0; i < menuItemElement.length; i++) {
	menuItemElement[i].addEventListener("click", () => {
		menuElement.classList.add('d-none');
	});
}

const baseIssueCount = 32299514;
const countTimestamp = 1549893762;
const dailyIssueCount = 3802240;

const numberWithSpaces = (number) => {
	return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};

const getRandomArbitrary = (min, max) => {
	return Math.random() * (max - min) + min;
};

const printCount = () => {
	let currentTimestamp = Math.floor(Date.now() / 1000);
	let diffSeconds = currentTimestamp - countTimestamp;
	let diffCount = Math.round(diffSeconds / (24 * 60 * 60) * dailyIssueCount + getRandomArbitrary(0, 6));

	issueCountElement.innerText = numberWithSpaces(baseIssueCount + diffCount);
};

if (issueCountElement) {
	printCount();

	setInterval(printCount, 6000);
}

/*
if ('serviceWorker' in navigator)
    navigator.serviceWorker.register('/sw.js?v' + process.env.VERSION);
}
*/
